<template>
  <div class="star">
    <button
      v-for="(item,index) in originResource"
      :key="index"
     :class="['star__item',item?'check':'']"
      @focus="click($event,item,index)"
      @click="click1($event,item,index)"
    ></button>
    <p class="desc">
      <span :class="{nochoose: count == 0}">{{comment}}</span>
      <span v-show="count!=0">{{count}}分</span>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      originResource: [false, false, false, false, false], //原始数据
      count: 0 //选中的星星个数默认为0
    };
  },

  props: {
    star: {
      //使用组件时必须设置初始选中星星的个数
      type: Number,
      required: true,
    
    }
  },
  computed: {
    comment() {
      let comments = "";
      switch (this.count) {
        case 0:
          comments = "点亮上面的小星星，每个星星代表1分";
          break;
        case 1:
          comments = "很差";
          break;
        case 2:
          comments = "不满意";
          break;
        case 3:
          comments = "一般般";
          break;
        case 4:
          comments = "比较满意";
          break;
        case 5:
          comments = "非常满意";
          break;
      }

      return comments;
    }
  },
  mounted() {
    this.refreshComponent(this.star);
  },
  methods: {
    /**
     * @param checked 点击星星的选中状态
     * @param index 点击星星的选中下标
     * @description 根据所点击星星的状态，切换显示图标的样式
     */
    click(e,checked, index) {

      if (checked) {
        this.refreshComponent(index);
      } else {
        this.refreshComponent(index + 1);
      }
      this.getCount();
      e.target.blur();

   
    },
       click1(e,checked, index) {
         let isSafari=/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
       if(!isSafari)return;
      
      if (checked) {
        this.refreshComponent(index);
      } else {
        this.refreshComponent(index + 1);
      }
      this.getCount();
      e.target.blur();
    },
    /**
     * @param num 设置星星选中的个数
     * @description 更新组件
     */
    refreshComponent(num) {
      this.count = num;
      this.originResource = [
        ...new Array(num).fill(true),
        ...new Array(5 - num).fill(false)
      ];
    },
    /**
     * @description 向组件外提供选中个数
     */
    getCount() {
      this.$emit("getCount", this.count);
    }
  }
};
</script>
<style lang="less" scoped>
.star__item {
  margin-right: 11px;
  width: 57px;
  height: 57px;
  background: url(./img/star_uncheck.png) no-repeat center/100%;
}
.check{
   background: url(./img/star_check.png) no-repeat center/100%;
}
.desc {
  font-size: 16px;
  color: #f57f22;
  font-family:  PingFang_Regular;
  line-height: 16px;
  margin-top: 10px;
  span {
    &:first-child {
      margin-right: 12px;
    }
  }
}
.nochoose{
  color: #8997A1;
}
</style>








// WEBPACK FOOTER //
// src/components/basic/star/star.vue